import { unauthorizedApi } from "api";
import { Account } from "domain/accounts";

import { User, UserPermissions } from "domain/users";

export interface LoginPayload {
  email: string;
  password: string;
}

export interface LoginResponse {
  token: string;
  user: User;
  permissions: UserPermissions;
  defaultAccount: Account;
  availableAccounts: Account[];
}

const PATH = "/auth/v2/signin";

export const loginRequest = async ({ email, password }: LoginPayload) => {
  const res = await unauthorizedApi.post<LoginResponse>(PATH, {
    email,
    password,
  });

  return res.data;
};
